import useSWR from 'swr';
import { customSWRConfig, customSWRResponse, Event, KeysMatching } from '../../model/types';
import { by, sortType, sortTypeObjectMap } from '../../utils/helpers';
import useSWRCacheKeys from '../useSWRCacheKeys';

const sortEventListByGivenObjectKey = <T extends Event, K extends KeysMatching<T, number>>(
    data: T[],
    key: K,
    sortType: sortType = sortTypeObjectMap.descending
) => data?.sort(by<T>(key)(sortType));

export default function useEvents(ticketKey: string, config: customSWRConfig = {}): customSWRResponse<Event[]> {
    const keys = useSWRCacheKeys(ticketKey ? `/changes/${ticketKey}` : null);

    return useSWR(keys, { ...config });
}

export { sortEventListByGivenObjectKey };
